import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VTabs, {
    staticClass: "px-4 mt-4"
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-de",
      "justify": "center"
    }
  }, [_c(VAvatar, {
    staticClass: "flag-icon flag-icon-de color-lang",
    staticStyle: {
      "background-size": "132% 100%"
    },
    attrs: {
      "size": "22"
    }
  }), _vm._v("\n      Deutsch\n  ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-en",
      "justify": "center"
    }
  }, [_c(VAvatar, {
    staticClass: "flag-icon flag-icon-gb color-lang",
    staticStyle: {
      "background-size": "132% 100%"
    },
    attrs: {
      "size": "22"
    }
  }), _vm._v("\n      English\n  ")], 1), _vm._l(['de', 'en'], function (l) {
    return _c(VTabItem, {
      key: l,
      attrs: {
        "value": 'tab-' + l
      }
    }, [_c(VTextField, {
      staticClass: "body-template mt-6",
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.termsAndConditions.titleInput'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      model: {
        value: _vm.termsAndConditions.title[l],
        callback: function ($$v) {
          _vm.$set(_vm.termsAndConditions.title, l, $$v);
        },
        expression: "termsAndConditions.title[l]"
      }
    }), _vm.markdownEdit ? _c(VCard, {
      staticClass: "elevation-0 v-card-text-area mdbox mt-6",
      attrs: {
        "outlined": ""
      }
    }, [_c(VCardText, [_c('markdown-it-vue-light', {
      attrs: {
        "content": _vm.termsAndConditions[l] || ''
      }
    })], 1)], 1) : _c(VCard, [_c(VTextarea, {
      staticClass: "body-template mt-6",
      attrs: {
        "label": _vm.$i18n_t('Common.description'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rows": "15",
        "hide-details": ""
      },
      model: {
        value: _vm.termsAndConditions[l],
        callback: function ($$v) {
          _vm.$set(_vm.termsAndConditions, l, $$v);
        },
        expression: "termsAndConditions[l]"
      }
    })], 1), _c(VSwitch, {
      staticClass: "ma-0 pa-0",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": _vm.$i18n_t('Common.mdeditor'),
        "color": _vm.color
      },
      model: {
        value: _vm.markdownEdit,
        callback: function ($$v) {
          _vm.markdownEdit = $$v;
        },
        expression: "markdownEdit"
      }
    })], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };